import { GroupId } from '../../core/groups/entities/group.entity';
import { OrganisationId } from '../../core/organisations/entities/organisation.entity';
import { ApiStructuredQuery, StructuredQuery } from '../../core/query/entities/structured-query.entity';
import { QueryParser } from '../../core/query/helpers/query-parser.helper';
import { QueryPartsToStructuredQuery } from '../../core/query/helpers/structured-query.helper';
import { Comparable } from '../../helpers/entities/comparable.interface';
import { Trackable } from '../../helpers/entities/trackable.interface';
import { EmptyStructuredQuery } from '../../public_api';
import { ApiStructuredQueryToStructuredQuery } from '../helpers/convert-structured-query.helper';

enum SavedQueryIdBrand {
    _ = ''
}
export type SavedQueryId = string & SavedQueryIdBrand;

export interface QueryInfo {
    readonly Name: string;
    readonly Groups: GroupId[];
}

export interface ISavedQuery extends QueryInfo {
    readonly Id: SavedQueryId;
    readonly CreatedBy: string;
    readonly OrganisationId: OrganisationId;
    readonly Query: string;
    readonly StructuredQuery: ApiStructuredQuery | null;
}

export class SavedQuery implements Comparable, Trackable {
    readonly Id: SavedQueryId;
    readonly Name: string;
    readonly Groups: GroupId[];
    readonly CreatedBy: string;
    readonly Query: string;
    readonly StructuredQuery: StructuredQuery;
    readonly OrganisationId: OrganisationId;
    readonly ValidQuery: boolean = true;

    constructor(savedQuery: ISavedQuery, queryParser: QueryParser) {
        this.Id = savedQuery.Id;
        this.Name = savedQuery.Name;
        this.Groups = savedQuery.Groups;
        this.CreatedBy = savedQuery.CreatedBy;
        this.Query = savedQuery.Query;
        this.OrganisationId = savedQuery.OrganisationId;

        if (savedQuery.StructuredQuery) {
            this.StructuredQuery = ApiStructuredQueryToStructuredQuery(savedQuery.StructuredQuery);
        } else {
            try {
                this.StructuredQuery = QueryPartsToStructuredQuery(
                    queryParser.luceneQueryToQueryParts(savedQuery.Query)
                );
            } catch {
                this.StructuredQuery = EmptyStructuredQuery;
                this.ValidQuery = false;
                console.error(`Failed to convert Query to a StructuredQuery.`, this.Query);
            }
        }
    }

    equals(other: any): boolean {
        if (!(other instanceof SavedQuery)) {
            return false;
        }
        return this.Id === other.Id;
    }

    trackBy(): string {
        return this.Id;
    }
}
